module.exports = __webpack_public_path__ + "static/media/logo-marr-main.0ddc6bd4.png";